import 'angular:locale/data:en-EN';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-EN";
